import { isBrowser } from 'acq-utils/lib/misc';

export const getIsomorphicCookies = () =>
  isBrowser() ? document.cookie : global.cookies;
